<template>
  <div class="player-roles-toggles">
    <div class="form-row">
      <gam-switch v-bind="getCoachSwitch()" @update:checked="handleUpdateCoach" class="switch" />
    </div>

    <div class="form-row">
      <gam-switch v-bind="getStreamerSwitch()" @update:checked="handleUpdateStreamer" class="switch" />
    </div>
  </div>
</template>

<script setup lang="ts">
import GamSwitch from '@/views/components/GamSwitch.vue';
import { GamSwitchPosition, GamSwitchValueType } from '@/views/composables/constants/components/gamSwitch.constants';
import type { GamSwitchType } from '@/views/composables/models/components/GamSwitch';

const emit = defineEmits<(e: 'update:coach' | 'update:streamer', value: boolean) => void>();

const props = defineProps<{
  coachRole: boolean;
  streamerRole: boolean;
}>();

const handleUpdateStreamer = (value: boolean) => {
  emit('update:streamer', value);
};

const handleUpdateCoach = (value: boolean) => {
  emit('update:coach', value);
};

const getStreamerSwitch = (): GamSwitchType => {
  return {
    name: 'streamer',
    label: 'profile.my.general.section.type.streamer.title',
    type: GamSwitchValueType.SWITCH,
    position: GamSwitchPosition.LEFT,
    checked: props.streamerRole,
  };
};

const getCoachSwitch = (): GamSwitchType => {
  return {
    name: 'coach',
    label: 'profile.my.general.section.type.coach.title',
    type: GamSwitchValueType.SWITCH,
    position: GamSwitchPosition.LEFT,
    checked: props.coachRole,
  };
};
</script>

<style scoped lang="scss">
.player-roles-toggles {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-xl);
  align-self: stretch;

  .form-row {
    width: 100%;
    display: flex;
    gap: var(--spacing-md);
  }
}
</style>
